import React from "react";
import { Field, FieldInputProps, FormikProps } from "formik";
import { FieldDefinition } from "../../../types/formMaps";
import PlainTextDisplay from "./PlainTextDisplay";
interface DataPointProps {
  values: any;
  fieldDef: FieldDefinition;
}

export const DataPoint: React.FC<DataPointProps> = ({ values, fieldDef }) => {
  return (
    <div className="flex grid grid-cols-12 w-full px-4">
      <div className="font-semibold text-black col-span-3 md-col-span-6 truncate">
        {fieldDef.label}
      </div>
      <div className="text-gray-700 col-span-6">
        <Field name={fieldDef.name}>
          {({
            field,
            form: { touched, errors },
            meta,
          }: {
            field: FieldInputProps<any>;
            form: FormikProps<any>;
            meta: any;
          }) => (
            <div className="p-3 text-sm text-gray-900 max-w-32">
              <PlainTextDisplay
                value={values[fieldDef.name]}
                fieldType={fieldDef.type}
              />
            </div>
          )}
        </Field>
      </div>
    </div>
  );
};
